import { render, staticRenderFns } from "./AcuteToxList.vue?vue&type=template&id=c431f666&"
import script from "./AcuteToxList.vue?vue&type=script&lang=js&"
export * from "./AcuteToxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports